
    import {defineComponent, reactive} from 'vue'
    import {useRoute} from "vue-router";

    interface State {
        contentText: object[];
    }
    export default defineComponent({
        name: "explainFreeAuth",
        setup() {
            let state: State = reactive({
                contentText: [
                    {
                        title: '购买流程',
                        content: [
                            '经过质保准入合格→在【268V检测】微信小程序中付费购买对应质保服务产品→提供所需材料开启质保→质保服务生效。'
                        ]
                    },
                    {
                        title: '质保服务',
                        content: [
                            '针对在服务方保障范围内的零部件失效而进行的维修或置换服务，并秉承“以修为主，以换为辅”的原则。'
                        ]
                    },
                    {
                        title: '服务期限',
                        content: [
                            '保修期限：12个月（精选保障plus产品可享一年不限公里保修）；',
                            '保修期起算时间：开启质保服务的次日，具体以服务单中列明的日期为准。'
                        ]
                    },
                    {
                        title: '服务范围'
                    },
                    {
                        title: '保修范围说明',
                        content: [
                            '1.上述保修零部件发生故障时，服务方的判定结果具有保修赔付决定权。',
                            'prop_up_height20',
                            '2.带下划线零部件，只承保是由于某个其它受保机械部件出现故障时，同时造成的损坏或必须同时更换或拆装的费用。',
                            'prop_up_height20',
                            '3.在替换所承保故障零件时，有必要进行更换的有关辅料（油、液和滤芯等）给予更换。',
                            'prop_up_height20',
                            '4.修理中进行更换所使用的零部件应与原厂或与原厂部件种类相同或者相似、质量相同或者相似，并且与汽车原设计规格和耐用程度吻合。'
                        ]
                    },
                ]
            })
            const {query} = useRoute();

            return {
                state
            }
        },
        methods: {
            goBack(){
                history.go(-1)
            }
        }
    })
